export default __webpack_public_path__ + "static/linked-list-deletion-8ed4f5d8e607d6e5b089f7dd4da5c8fc.png";